module.exports = __webpack_public_path__ + "static/media/web2.4746e47d.jpg";